export interface HallOfFameEntry {
  id: string;
  slug: string;
  name: string;
  story: string | null;
  category: string | null;
  closed_at: string | null;
  peak_members: number | null;
  peak_posts: number | null;
  wayback_url: string | null;
}

/** Site içi varsayılan liste — ziyaretçiye teknik detay gösterilmez */
export const DEFAULT_HALL_OF_FAME_ENTRIES: HallOfFameEntry[] = [
  {
    id: 'hof-pcnet',
    slug: 'pcnet',
    name: 'PCnet',
    category: 'Teknoloji Forumu',
    story:
      "2000'lerin başında Türkiye'nin en büyük teknoloji forumlarından biriydi. Donanım tartışmaları, sürücü desteği ve geniş kullanıcı kitlesiyle yıllarca referans kaynak oldu.",
    closed_at: '2020-09-23',
    peak_members: 180922,
    peak_posts: 1261763,
    wayback_url: 'https://web.archive.org/web/20200923233214/http://www.pcnet.com.tr/forum/forum/',
  },
  {
    id: 'hof-yorumkat',
    slug: 'yorumkat',
    name: 'Yorum Kat',
    category: 'Genel & Sohbet',
    story:
      'Geniş kitleli sohbet ve gündem tartışmalarıyla öne çıkan devasa bir topluluktu. Milyonlarca ileti ve yüz binlerce üyeyle Türk forum kültürünün simgelerinden biri olarak anılır.',
    closed_at: '2015-05-22',
    peak_members: 581890,
    peak_posts: 1995455,
    wayback_url: 'https://web.archive.org/web/20150522222351/http://yorumkat.com/',
  },
  {
    id: 'hof-torrent-oyun',
    slug: 'torrent-oyun',
    name: 'Torrent Oyun',
    category: 'Oyun Forumu',
    story:
      'Oyun dünyasına dair rehberler, tartışmalar ve arşiv paylaşımlarıyla büyüyen bir oyuncu topluluğu kurdu. SMF altyapısıyla uzun yıllar aktif kaldı.',
    closed_at: '2018-08-06',
    peak_members: 506221,
    peak_posts: 3889903,
    wayback_url:
      'https://web.archive.org/web/20180806140634/http://www.torrent-oyun.com/index.php?action=forum',
  },
  {
    id: 'hof-macawforum',
    slug: 'macawforum',
    name: 'Macaw Forum',
    category: 'Genel & Sohbet',
    story:
      'Kısa sürede çok hızlı büyüyen, yoğun trafik alan bir sosyal forum deneyimiydi. Konu ve ileti sayılarıyla döneminin en dikkat çeken platformları arasında yer aldı.',
    closed_at: '2022-04-30',
    peak_members: 1312285,
    peak_posts: 2599094,
    wayback_url: 'https://web.archive.org/web/20220430000806/https://macawforum.com/',
  },
  {
    id: 'hof-crackerteam',
    slug: 'crackerteam',
    name: 'Cracker Team',
    category: 'Siber Güvenlik',
    story:
      'Siber güvenlik, yazılım ve dijital kültür odaklı uzman bir topluluktu. Yüz binlerce üyesiyle niş ama çok aktif bir forum ekosistemi oluşturdu.',
    closed_at: '2025-11-09',
    peak_members: 122468,
    peak_posts: 4217376,
    wayback_url: 'https://web.archive.org/web/*/https://www.crackerteam.com',
  },
  {
    id: 'hof-risaleforum',
    slug: 'risaleforumcom',
    name: 'Risale Forum.com',
    category: 'Dini Forum',
    story:
      'İlahiyat ve manevi içerik etrafında şekillenen, yıllarca süren düzenli bir tartışma ortamı sundu. Geniş arşiviyle topluluğuna uzun süre ev sahipliği yaptı.',
    closed_at: '2025-07-16',
    peak_members: 41014,
    peak_posts: 448413,
    wayback_url: 'https://web.archive.org/web/*/https://www.risaleforum.com',
  },
  {
    id: 'hof-kodevelopers',
    slug: 'kodevelopers',
    name: 'KO Developers',
    category: 'Oyun Forumu',
    story:
      'Knight Online odaklı rehberler, geliştirici paylaşımları ve oyuncu dayanışmasıyla tanındı. Türkiye oyun forumları arasında sadık bir çekirdek topluluk bıraktı.',
    closed_at: '2025-07-17',
    peak_members: 11768,
    peak_posts: 61544,
    wayback_url: 'https://web.archive.org/web/*/https://www.kodevelopers.com',
  },
  {
    id: 'hof-donanimmerkezi',
    slug: 'donanimmerkezi',
    name: 'Donanım Merkezi',
    category: 'Teknoloji Forumu',
    story:
      'Donanım meraklılarının teknik sorularını paylaştığı, modüler ve sade yapılı klasik bir vBulletin topluluğuydu. On binlerce üyesiyle uzun yıllar ayakta kaldı.',
    closed_at: '2025-07-16',
    peak_members: 54088,
    peak_posts: 79884,
    wayback_url: 'https://web.archive.org/web/*/https://www.donanimmerkezi.com',
  },
];
